import type { AdNetworkRadio } from '@/pages/sa/ad-network/types';

type RadioParticipationStatus = 'activo' | 'inactivo';

export interface AdNetworkRadio {
  id: number;
  radioName: string;
  radioFrequency: string;
  radioCity: string;
  plan: string;
  participating: boolean;
  status: RadioParticipationStatus;
  impressions: number;
  clicks: number;
  ctr: number;
  radioRevenue: number;
  rfwRevenue: number;
  activatedAt: string;
  lastUpdated: string;
}

export const adNetworkRadios: AdNetworkRadio[] = [
  {
    id: 1,
    radioName: 'Radio Éxito',
    radioFrequency: '98.5 FM',
    radioCity: 'Madrid',
    plan: 'Premium',
    participating: true,
    status: 'activo',
    impressions: 458200,
    clicks: 38740,
    ctr: 8.46,
    radioRevenue: 6873,
    rfwRevenue: 4582,
    activatedAt: '2025-11-03',
    lastUpdated: '2026-06-16',
  },
  {
    id: 2,
    radioName: 'La Nueva FM',
    radioFrequency: '104.3 FM',
    radioCity: 'Barcelona',
    plan: 'Premium',
    participating: true,
    status: 'activo',
    impressions: 312900,
    clicks: 21450,
    ctr: 6.85,
    radioRevenue: 4693,
    rfwRevenue: 3129,
    activatedAt: '2025-12-10',
    lastUpdated: '2026-06-16',
  },
  {
    id: 3,
    radioName: 'Radio Caliente',
    radioFrequency: '91.7 FM',
    radioCity: 'Sevilla',
    plan: 'Estándar',
    participating: true,
    status: 'activo',
    impressions: 289400,
    clicks: 17364,
    ctr: 6.00,
    radioRevenue: 4341,
    rfwRevenue: 2894,
    activatedAt: '2026-01-15',
    lastUpdated: '2026-06-15',
  },
  {
    id: 4,
    radioName: 'Voz del Pueblo',
    radioFrequency: '107.1 FM',
    radioCity: 'Valencia',
    plan: 'Premium',
    participating: true,
    status: 'activo',
    impressions: 567100,
    clicks: 52170,
    ctr: 9.20,
    radioRevenue: 8506,
    rfwRevenue: 5671,
    activatedAt: '2025-10-01',
    lastUpdated: '2026-06-16',
  },
  {
    id: 5,
    radioName: 'Onda Digital',
    radioFrequency: '96.2 FM',
    radioCity: 'Bilbao',
    plan: 'Estándar',
    participating: true,
    status: 'activo',
    impressions: 201800,
    clicks: 14126,
    ctr: 7.00,
    radioRevenue: 3027,
    rfwRevenue: 2018,
    activatedAt: '2026-02-20',
    lastUpdated: '2026-06-14',
  },
  {
    id: 6,
    radioName: 'Radio Sol',
    radioFrequency: '102.8 FM',
    radioCity: 'Málaga',
    plan: 'Premium',
    participating: false,
    status: 'inactivo',
    impressions: 0,
    clicks: 0,
    ctr: 0,
    radioRevenue: 0,
    rfwRevenue: 0,
    activatedAt: '—',
    lastUpdated: '—',
  },
  {
    id: 7,
    radioName: 'FM Latina',
    radioFrequency: '95.1 FM',
    radioCity: 'Zaragoza',
    plan: 'Estándar',
    participating: true,
    status: 'activo',
    impressions: 178300,
    clicks: 12481,
    ctr: 7.00,
    radioRevenue: 2674,
    rfwRevenue: 1783,
    activatedAt: '2026-03-05',
    lastUpdated: '2026-06-15',
  },
  {
    id: 8,
    radioName: 'Radio Mar',
    radioFrequency: '89.4 FM',
    radioCity: 'A Coruña',
    plan: 'Básico',
    participating: true,
    status: 'activo',
    impressions: 145600,
    clicks: 8736,
    ctr: 6.00,
    radioRevenue: 2184,
    rfwRevenue: 1456,
    activatedAt: '2026-04-12',
    lastUpdated: '2026-06-16',
  },
  {
    id: 9,
    radioName: 'Estéreo Norte',
    radioFrequency: '101.5 FM',
    radioCity: 'Santander',
    plan: 'Estándar',
    participating: false,
    status: 'inactivo',
    impressions: 0,
    clicks: 0,
    ctr: 0,
    radioRevenue: 0,
    rfwRevenue: 0,
    activatedAt: '—',
    lastUpdated: '—',
  },
  {
    id: 10,
    radioName: 'Radio Capital',
    radioFrequency: '93.9 FM',
    radioCity: 'Madrid',
    plan: 'Premium',
    participating: true,
    status: 'activo',
    impressions: 634500,
    clicks: 59010,
    ctr: 9.30,
    radioRevenue: 9517,
    rfwRevenue: 6345,
    activatedAt: '2025-09-15',
    lastUpdated: '2026-06-16',
  },
  {
    id: 11,
    radioName: 'Urbana Radio',
    radioFrequency: '106.7 FM',
    radioCity: 'Granada',
    plan: 'Básico',
    participating: true,
    status: 'activo',
    impressions: 112400,
    clicks: 6744,
    ctr: 6.00,
    radioRevenue: 1686,
    rfwRevenue: 1124,
    activatedAt: '2026-05-01',
    lastUpdated: '2026-06-14',
  },
  {
    id: 12,
    radioName: 'Radio Tropical',
    radioFrequency: '88.3 FM',
    radioCity: 'Las Palmas',
    plan: 'Estándar',
    participating: false,
    status: 'inactivo',
    impressions: 0,
    clicks: 0,
    ctr: 0,
    radioRevenue: 0,
    rfwRevenue: 0,
    activatedAt: '—',
    lastUpdated: '—',
  },
];

export const adNetworkMetrics = {
  totalRadios: 12,
  participatingRadios: 9,
  totalImpressions: 2900200,
  totalClicks: 230821,
  avgCtr: 7.53,
  totalRadioRevenue: 43503,
  totalRfwRevenue: 29002,
  radioPercent: 60,
  rfwPercent: 40,
};